import axios from 'axios';
import React, { useEffect, useState } from 'react';

function LessonDetails({ lesson, onClose }) {
    const [lessonContent, setLessonContent] = useState('');
    const [lessonPage, setLessonPage] = useState('');
    const [homework, setHomework] = useState('');
    const [test, setTest] = useState('');
    const [hidingTest, setHidingTest] = useState('');
    const [hidingHomework, setHidingHomework] = useState('');
    const [hwDueLesson, setHwDueLesson] = useState('');
    const [printingMaterial, setPrintingMaterial] = useState('');

    const apiUrl = process.env.REACT_APP_API_URL;

    // Use useEffect to update the state when the lesson prop changes
    useEffect(() => {
        if (lesson) {
            setLessonContent(lesson.lesson_content || '');
            setLessonPage(lesson.lesson_page || '');
            setHomework(lesson.homework || '');
            setTest(lesson.test || '');
            setPrintingMaterial(lesson.printing_materials || ''); 
            setHidingHomework(lesson.hiding_homework || '');
            setHwDueLesson(lesson.hw_due_lesson == null ? '' : String(lesson.hw_due_lesson));
            setHidingTest(lesson.hiding_test || '');
        }
    }, [lesson]);

    // Frontend
    const handleUpdate = async () => {
        try {
            // Sanitize lesson_id to remove spaces or invalid characters
            const sanitizedLessonId = lesson.lesson_id
            // .replace(/\s+/g, ''); // Remove all spaces
            const response = await axios.patch(`${process.env.REACT_APP_API_URL}/admin/updateLesson/${sanitizedLessonId}`, {
                lesson_content: lessonContent,
                lesson_page: lessonPage,
                homework,
                test,
                printing_materials: printingMaterial,  
                hiding_homework: hidingHomework,
                hw_due_lesson: hwDueLesson === '' ? null : parseInt(hwDueLesson, 10),
                hiding_test: hidingTest,
            });
            if (response.data.success) {
                onClose(); // Close the modal after successful update
                alert('updated lesson.');
            }
        } catch (error) {
            console.error('Error updating lesson:', error);
            alert('Failed to update lesson.');
        }
    };
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg w-1/2">
                <h2 className="text-lg font-semibold mb-4">Edit Lesson: {lesson.lesson_id}</h2>
                
                <input
                    type="text"
                    placeholder="Lesson Content"
                    value={lessonContent}
                    onChange={(e) => setLessonContent(e.target.value)}
                    className="w-full px-3 py-2 mb-3 border rounded"
                />
                <input
                    type="text"
                    placeholder="Lesson Page"
                    value={lessonPage}
                    onChange={(e) => setLessonPage(e.target.value)}
                    className="w-full px-3 py-2 mb-3 border rounded"
                />
                <input
                    type="text"
                    placeholder="Homework"
                    value={homework}
                    onChange={(e) => setHomework(e.target.value)}
                    className="w-full px-3 py-2 mb-3 border rounded"
                />
                <input
                    type="text"
                    placeholder="Test"
                    value={test}
                    onChange={(e) => setTest(e.target.value)}
                    className="w-full px-3 py-2 mb-3 border rounded"
                />
                <input
                    type="text"
                    placeholder="Printing Material"
                    value={printingMaterial}
                    onChange={(e) => setPrintingMaterial(e.target.value)}
                    className="w-full px-3 py-2 mb-3 border rounded"
                />
                <input
                    type="text"
                    placeholder="Hiding Test"
                    value={hidingTest}
                    onChange={(e) => setHidingTest(e.target.value)}
                    className="w-full px-3 py-2 mb-3 border rounded"
                />
                <div className="flex gap-2 mb-3">
                    <input
                        type="text"
                        placeholder="Hiding Homework"
                        value={hidingHomework}
                        onChange={(e) => setHidingHomework(e.target.value)}
                        className="flex-1 px-3 py-2 border rounded"
                    />
                    <input
                        type="number"
                        placeholder="Due lesson link"
                        value={hwDueLesson}
                        onChange={(e) => setHwDueLesson(e.target.value)}
                        className="w-36 px-3 py-2 border rounded"
                    />
                </div>
                <div className="flex justify-end space-x-2">
                    <button onClick={handleUpdate} className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600">
                        Update
                    </button>
                    <button onClick={onClose} className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}

export default LessonDetails;